import {
  Box,
  Text,
  VStack,
  HStack,
  IconButton,
  Icon,
  Spinner,
} from '@chakra-ui/react';

import { FiDownload, FiFile, FiFileText, FiPaperclip } from 'react-icons/fi';
import {
  getAttachmentBgColor,
  getFileIconBgColor,
  openFileInNewTab,
} from './conversation-utils';

import { MessageAttachment } from '@/features/messages/messages.types';

export const MessageAttachmentFile = ({
  isUser,
  isAIAgent,
  messageStatus,
  attachment,
}: {
  isUser: boolean;
  isAIAgent: boolean;
  messageStatus: string;
  attachment: MessageAttachment;
}) => {
  if (!attachment) {
    return null;
  }

  return (
    <Box
      p={2}
      borderRadius="md"
      bg={getAttachmentBgColor(isUser, isAIAgent)}
      width="100%"
      cursor="pointer"
      onClick={() => openFileInNewTab(attachment.file_url)}
      position="relative"
      opacity={
        messageStatus === 'pending' || messageStatus === 'sending' ? 0.8 : 1
      }
    >
      {/* Add loading indicator for pending and sending states */}
      {(messageStatus === 'pending' || messageStatus === 'sending') && (
        <Spinner
          size="sm"
          position="absolute"
          top="3px"
          right="3px"
          color="white"
        />
      )}

      <HStack gap={3} align="center">
        <Box borderRadius="md" p={2} bg={getFileIconBgColor(isUser, isAIAgent)}>
          {attachment.file_type === 'pdf' ? (
            <Icon as={FiFile} boxSize={6} color="red.500" />
          ) : attachment.file_type === 'docx' ? (
            <Icon as={FiFileText} boxSize={6} color="blue.600" />
          ) : (
            <Icon as={FiPaperclip} boxSize={6} />
          )}
        </Box>

        <VStack align="start" gap={0} flex="1">
          <Text fontSize="sm" fontWeight="medium">
            {attachment.file_name || 'File attachment'}
          </Text>
          <Text fontSize="xs" opacity={0.8}>
            {attachment.file_type ? attachment.file_type.toUpperCase() : 'File'}
          </Text>
        </VStack>

        <IconButton
          aria-label="Open file"
          size="sm"
          colorPalette={isUser ? 'gray' : isAIAgent ? 'green' : 'blue'}
          variant="ghost"
          onClick={(e) => {
            e.stopPropagation(); // Prevent the parent click from firing
            window.open(attachment.file_url, '_blank');
          }}
        >
          <FiDownload />
        </IconButton>
      </HStack>
    </Box>
  );
};
